<template>
  <div class="">
    <div class="search">
      <el-form inline="true" :model="wxSystemVo" :rules="rules" class="module_from_search">
        <el-form-item label="平台标识" prop="sId" class="queryHeight">
          <el-input class="queryInput" v-model="wxSystemVo.id" placeholder="请输入内容" clearable></el-input>
        </el-form-item>
        <el-form-item label="平台名称" prop="sName">
          <el-input class="queryInput" v-model="wxSystemVo.name" placeholder="请输入内容" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="buttonWidth queryButton" id="query" type="primary" @click="queryPlatByCondition">查询
          </el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button class="buttonWidth" type="primary" @click="addPlat">添加</el-button>
      </div>
    </div>
    <el-table
        :data="tableData"
        border
        stripe
        :header-cell-style='headerStyle'
        :row-style="{height:'35px'}"
        :cell-style="{padding:'0px'}"
        class="tableStyle">
      <el-table-column prop="number" width="60" label="序号" align="center">
        <template v-slot="scope">
          <span>{{ (queryVo.pageNum - 1) * queryVo.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="平台标识" align="left"></el-table-column>
      <el-table-column prop="name" label="平台名称" align="left"></el-table-column>
      <el-table-column prop="createUser" label="创建人" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template v-slot="scope">
          <el-button type="text" @click="editPlat(scope.row)">编辑</el-button>
          <el-button type="text" @click="downloadPlat(scope.row)">下载</el-button>
          <el-button type="text" @click="deletePlat(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <center>
      <div class="block">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryVo.pageNum"
            :page-sizes="[10, 20, 30]"
            :page-size="queryVo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </center>
  </div>
  <platform-add-dialog ref="platformAddDialog"></platform-add-dialog>
</template>
<script>
import platformAddDialog from './platformAddDialog.vue';

export default {
  components: {platformAddDialog},
  name: 'platformConfigurationTable',
  data() {
    return {
      wxSystemVo: {
        id: '',
        name: ''
      },
      queryVo: {
        pageSize: 10,
        pageNum: 1,
        id: '',
        name: '',
        userId: ''
      },
      platDetail: {
        id: '',
        ip: '',
        name: '',
        token: '',
        version: '',
        otherVersion: '',
        description: '',
        type: 0
      },
      visibleFlg: 'false',
      headerStyle: {
        'color': '#333333',
        'font-size': '14px',
        'font-weight': '35',
        'text-align': 'center',
        'background-color': '#E3E3E3',
      },
      tableData: [],
      editModule: '',
      total: 10
    }
  },
  mounted() {
    document.getElementsByClassName("el-pagination__jump")[0].childNodes[0].nodeValue = "跳至";
  },
  created() {
    this.queryVo.userId = sessionStorage.getItem("sid");
    this.queryMessage();
  },
  methods: {
    /**
     * @description 查询平台信息
     */
    queryMessage() {
      this.$api.post(true, "/wxSystem/queryWxSystem", this.queryVo, res => {
        this.tableData = res.data.content.resultlist;
        this.total = res.data.content.total;
      })
    },
    /**
     * @description 条件查询平台信息
     */
    queryPlatByCondition() {
      this.queryVo.id = this.wxSystemVo.id;
      this.queryVo.name = this.wxSystemVo.name;
      this.queryVo.pageNum = 1;
      this.queryMessage();
      this.$message.success("查询成功");
    },
    /**
     * @description 打开新增平台dialog
     */
    addPlat() {
      this.$refs.platformAddDialog.form = {...this.platDetail};
      this.$refs.platformAddDialog.title = '添加平台';
      this.$refs.platformAddDialog.visibleFlg = true;
    },
    /**
     * @description 监听分页器容量变化
     */
    handleSizeChange(value) {
      this.queryVo.pageSize = value;
      this.queryVo.pageNum = 1;
      this.queryMessage();
    },
    /**
     * @description 监听分页器页数变化
     */
    handleCurrentChange(value) {
      this.queryVo.pageNum = value;
      this.queryMessage();
    },
    /**
     * @description 编辑平台信息
     */
    editPlat(param) {
      let dialog = this.$refs.platformAddDialog;
      dialog.form = {...param};
      dialog.alertVersionMessage();
      dialog.title = '编辑平台';
      dialog.visibleFlg = true;
    },
    /**
     * @description 删除平台信息
     */
    deletePlat(id) {
      this.$confirm('此操作将删除该条信息，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.post(true, "/wxSystem/delWxSystem", {id}, res => {
          if (res.data.statusCode === 'API-COMMON-INF-OK') {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
          this.queryMessage();
        })
      })
    },
    downloadPlat(val){
      console.log(val);
      this.$api.post(true, '/WxQrCode/queryWxConfigByPlatForm', {appId: val.id, serviceType: ""}, res => {
        console.log(res.data.content);
        res.data.content.forEach(qrcode => {
          this.qrcodeDownLoad(qrcode);
        })
      })
    },
    qrcodeDownLoad (val) {
      //下载图片地址和图片名
      //文件名
      let name = val.ssystemId + val.sserviceId;
      //图片地址
      let imgsrc = val.sqrcode;
      let image = new Image()
      // 解决跨域 Canvas 污染问题
      image.crossOrigin = 'anonymous';
      image.onload = function() {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    }
  }
}
</script>
<style scoped>
.buttonWidth {
  width: 100px;
}

.queryInput {
  width: 200px;
  margin-right: 14px;
}

.queryButton {
  color: black;
  background-color: white;
  border-color: rgb(220 223 230);
}

.queryButton:hover {
  color: rgb(64 158 255);
  border-color: rgb(198 226 255);
  background-color: rgb(236 245 255);
}

.queryButton:active {
  color: rgb(64 158 255);
  border-color: rgb(58 142 230);
  background-color: rgb(236 245 255);
}

.tableStyle {
  width: 100%;
  margin-top: 15px;
}

.block {
  margin-top: 15px;
}
</style>
